/**
 * This function replaces the use of the deprecated function `url.parse()` from `node:url`.
 * Next.js uses the same object structure called `UrlObject` to push a new route and
 * using the URL API is the recommended way to build the `UrlObject` instead.
 * - [Next Router Documentation](https://nextjs.org/docs/api-reference/next/router#routerpush)
 * - [Legacy UrlObject](https://nodejs.org/api/url.html#legacy-urlobject)
 * @param {String} urlString
 * @param {Object} queryParams
 * @returns UrlObject
 */
const getNextJsUrlObject = (urlString, queryParams) => {
  const url = new URL(urlString, window.location);
  return {
    auth: [url.username, url.password].filter(String).join(":"),
    hash: url.hash,
    host: url.host,
    hostname: url.hostname,
    href: url.href,
    pathname: url.pathname,
    protocol: url.protocol,
    port: url.port,
    query: { ...Object.fromEntries(url.searchParams), ...queryParams },
    slashes: true,
  };
};

export default getNextJsUrlObject;
